/**
 * Copyright (c) 2022 Animation Studio Voronezh.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Animation Studio Voronezh.
 */

import { createStore, applyMiddleware } from "redux";
import resultReducer from "./reducers";
import ReduxThunk from "redux-thunk";

const store = createStore(resultReducer, applyMiddleware(ReduxThunk));

export default store;
